export default __webpack_public_path__ + "static/media/illustration.973575ef.png";